import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import isValidDate from 'date-fns/is_valid';
import isWithinRange from 'date-fns/is_within_range';
import formatDate from 'date-fns/format';
import minDate from 'date-fns/min';
import maxDate from 'date-fns/max';
import parseDate from 'date-fns/parse';
import TextInput from "../../TextInput";
import styles from "../styles.pcss";
var cx = classNames.bind(styles);
var dateToString = function dateToString(date) {
  return date && formatDate(date, 'DD.MM.YYYY') || '';
};
var formatRegexp = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(\d{4,4})$/i;
var stringToDate = function stringToDate(string) {
  var result;
  if (!string) {
    result = null;
  } else if (!formatRegexp.test(string)) {
    result = string;
  } else {
    var date = parseDate(string.replace(formatRegexp, '$3-$2-$1'));
    if (!isValidDate(date)) {
      result = string;
    }
    result = date;
  }
  return result;
};
var DateInputCustom = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DateInputCustom, _React$PureComponent);
  var _super = _createSuper(DateInputCustom);
  function DateInputCustom(_props) {
    var _this;
    _classCallCheck(this, DateInputCustom);
    _this = _super.call(this, _props);
    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (props) {
      return _this.setValue(dateToString(props.value));
    });
    _defineProperty(_assertThisInitialized(_this), "setValue", function (date) {
      return _this.setState({
        value: date
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (dateStr) {
      var date = stringToDate(dateStr);
      if (!date) {
        _this.props.onChange(null);
      } else if (typeof date === 'string') {
        _this.setValue(date);
      } else {
        var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;
        if (isWithinRange(date, min, max)) {
          _this.props.onChange(date);
        } else {
          _this.setValue(dateStr);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var date = stringToDate(_this.state.value);
      if (date) {
        if (typeof date === 'string') {
          _this.setValue(dateToString(_this.props.value));
        } else {
          var validDate = maxDate(_this.props.min, minDate(date, _this.props.max));
          _this.props.onChange(validDate);
          _this.setValue(dateToString(validDate));
        }
      }
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(TextInput, {
        className: cx('input', 'custom', "".concat(_this.props.size, "Size")),
        disabled: _this.props.disabled,
        mask: _this.props.mask,
        name: _this.props.name,
        onBlur: _this.handleBlur,
        onChange: _this.handleChange,
        onClick: _this.props.onClick,
        onFocus: _this.props.onFocus,
        placeholder: _this.props.placeholder,
        size: _this.props.size,
        status: _this.props.status,
        type: "text",
        value: _this.state.value,
        "data-t-id": "DateInput-components"
      });
    });
    _this.state = {
      value: dateToString(_props.value)
    };
    return _this;
  }
  return _createClass(DateInputCustom);
}(React.PureComponent);
_defineProperty(DateInputCustom, "defaultProps", {
  value: null,
  min: null,
  max: null,
  name: null,
  status: null
});
export { DateInputCustom as default };
DateInputCustom.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string,
  size: PropTypes.oneOf(['default', 'big']).isRequired,
  status: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  mask: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired
} : {};